import { Button, Avatar, App } from "antd";
import { SunOutlined, MoonOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import "./Schedule.scss";
import axios from "axios";
import { URL } from "../../../constant/url";
import { daysOfWeek } from "../dayOfWeek";
import { useStore } from "../../../components/globalstate/GlobalState";


const WeeklyShiftSchedule = ({ WorkingShiftData, setWorkingShiftData }) => {

  const { message } = App.useApp();

  const location = useStore((state) => state.location) || localStorage.getItem("selectedLocation");

  const normalizedData = daysOfWeek.map((day, idx) => {
    const found = WorkingShiftData.find((d) => d.day === day);
    const morning = found?.morningShift || [];
    const evening = found?.eveningShift || [];

    return {
      day,
      name: localStorage.getItem("cashier"),
      date: found?.date || dayjs().startOf("week").add(idx + 1, "day").format("MM/DD/YYYY"),
      morningShift: morning,
      eveningShift: evening,
      shifts: morning.length + evening.length,
    };
  });


  const isPastDate = (date) =>
    dayjs(date, "MM/DD/YYYY").isBefore(dayjs(), "day");



  const renderShiftCard = (employee, isEvening = false) => (
    <div
      key={`${employee.name}-${employee.startTime}-${employee.endTime}`}
      className={`shift-card ${isEvening ? "evening" : "morning"}`}
    >
      <div className="employee-info">
        <Avatar className="employee-avatar" size={32}>
          {employee.avatar}
        </Avatar>
        <div className="employee-details">
          <div className="employee-name">{employee.name}</div>
          <div className="employee-role">{employee.role}</div>
        </div>
      </div>
      <div className="shift-time">
        <div className="time-range">
          {employee.startTime} - {employee.endTime}
        </div>
        <div className="duration">{employee.duration}</div>
      </div>
    </div>
  );


  const addWorkingShiftAPI = async (shiftData) => {
    try {
      const res = await axios.post(`${URL}/api/addworkingshift`, shiftData);
      return res.data;
    } catch (err) {
      console.error("Error adding shift:", err.response?.data || err.message);
      message.error("Duplicate working shift.");
      throw err;
    }
  };

  const handleAddShift = async (dayIndex, isEvening) => {
    const user = localStorage.getItem("cashier") || "Unknown";

    const newEmployee = {
      name: user,
      location: location,
      role: "user",
      startTime: isEvening ? "13:00" : "05:00",
      endTime: isEvening ? "21:00" : "13:00",
      isWorkingDay: true,
      date: normalizedData[dayIndex].date,
    };

    try {
      const response = await addWorkingShiftAPI(newEmployee);
      const updatedDay = response.day;

      // Replace the correct day in schedule
      const newSchedule = [...normalizedData];
      newSchedule[dayIndex] = {
        ...updatedDay,
        shifts:
          (updatedDay.morningShift?.length || 0) +
          (updatedDay.eveningShift?.length || 0),
      };

      setWorkingShiftData(newSchedule);
    } catch (error) {
      console.error("Failed to add shift:", error);
    }
  };

  const renderAddButton = (dayIndex, isEvening = false) => {
    const isDisabled = isPastDate(normalizedData[dayIndex].date);
    return (
    <div className={`add-shift-card ${isEvening ? "evening" : "morning"}`}>
      <Button
        type="dashed"
        className="add-shift-button"
        disabled={isDisabled}
        onClick={() => handleAddShift(dayIndex, isEvening)}
      >
        Add working shift
      </Button>
    </div>
    );
  };


  // 🔹 Always show up to 2 slots (employee or add button)
  const renderShiftSlots = (shiftArray, dayIndex, isEvening) => {
    if (shiftArray.length === 0) {
      // no shift → show only one add button
      return [renderAddButton(dayIndex, isEvening)];
    }

    // if has data → still allow up to 2 slots
    const slots = [...shiftArray];
    if (slots.length < 2) {
      slots.push(null); // only add one more slot
    }

    return slots.map((employee) =>
      employee
        ? renderShiftCard(employee, isEvening)
        : renderAddButton(dayIndex, isEvening)
    );

  };



  return (
    <div className="weekly-shift-schedule">
      <div className="shift-headers">
        <div className="day-column">
          <span className="column-header">DAY</span>
        </div>
        <div className="morning-column">
          <span className="column-header">
            <SunOutlined className="shift-icon" />
            MORNING SHIFT
          </span>
        </div>
        <div className="evening-column">
          <span className="column-header">
            <MoonOutlined className="shift-icon" />
            EVENING SHIFT
          </span>
        </div>
      </div>

      <div className="schedule-content">
        {normalizedData.map((dayData, index) => (
          <div key={dayData.day} className="day-row">
            <div className="day-info">
              <div className="day-indicator"></div>
              <div className="day-details">
                <div className="day-name">{dayData.day}</div>
                <div className="day-date">{dayData.date}</div>
                <div className="shift-count">{dayData.shifts || 0} shifts</div>
              </div>
            </div>
            <div className="morning-shifts">
              {renderShiftSlots(dayData.morningShift, index, false)}
            </div>
            <div className="evening-shifts">
              {renderShiftSlots(dayData.eveningShift, index, true)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeeklyShiftSchedule;
